























































import { Component, Prop, Vue } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';
import { last } from 'lodash';

import PatientAcquisitionExportationFrameWalkingOverviewGauge from '@/components/patients/acquisition/exportation/frames/walking/overview/PatientAcquisitionExportationFrameWalkingOverviewGauge.vue';
import PatientAcquisitionExportationFrameFoot from '@/components/patients/acquisition/exportation/frames/PatientAcquisitionExportationFrameFoot.vue';

@Component({
  components: { PatientAcquisitionExportationFrameFoot, PatientAcquisitionExportationFrameWalkingOverviewGauge },
})
export default class PatientAcquisitionExportationFrameRunningBanner extends Vue {
  @Prop({ required: true }) private patient!: TEntity<TPatient>;
  @Prop({ required: true }) private acquisition!: TEntity<TAcquisition>;

  // -- CALCULS --------------------------------------------------------------------------------------------------------

  get duration() {
    const length = this.acquisition.computed_data.segments.length - 1;
    let startTime =
      (this.acquisition.computed_data.segments[length].left.header.start_time +
        this.acquisition.computed_data.segments[length].right.header.start_time) /
      2;
    let duration =
      (this.acquisition.computed_data.segments[length].left.header.duration +
        this.acquisition.computed_data.segments[length].right.header.duration) /
      2;
    const analysisTime = (this.$moment as any)
      .duration({
        seconds: (startTime + duration) / 32768,
      })
      .asMilliseconds();
    return this.$moment.utc(analysisTime).format('mm:ss');
  }

  get speed() {
    return (
      (this.acquisition!.computed_data.aggregates.left.running_speed.avg +
        this.acquisition!.computed_data.aggregates.right.running_speed.avg) /
      2
    ).toFixed(1);
  }

  get cadence() {
    return Math.round(
      this.acquisition!.computed_data.aggregates.left.cadence.avg +
        this.acquisition!.computed_data.aggregates.right.cadence.avg,
    );
  }

  get contactTime() {
    return {
      left: this.acquisition!.computed_data.aggregates.left.contact_time.avg,
      right: this.acquisition!.computed_data.aggregates.right.contact_time.avg,
    };
  }

  get asymmetry() {
    const leftContact = this.contactTime.left;
    const rightContact = this.contactTime.right;
    let substrack = (rightContact - leftContact) * 100;
    let add = (rightContact + leftContact) / 2;

    if (substrack && add) {
      const result = substrack / add;
      const isNegativeSymmetry = result < 0;
      const absResult = Math.abs(result);
      let range;

      switch (true) {
        case absResult < 2.5:
          range = 'orange';
          break;
        case absResult > 2.5 && absResult < 5:
          range = 'green';
          break;
        case absResult > 5 && absResult < 10:
          range = 'orange';
          break;
        default:
          range = 'red';
      }

      let left = isNegativeSymmetry ? 50 + absResult : 50 - absResult;
      let right = isNegativeSymmetry ? 50 - absResult : 50 + absResult;
      return {
        range: range,
        value: parseFloat((absResult / 2).toFixed(absResult / 2 < 1 ? 1 : 0)),
        leftOpacity: left > right ? 1 : 0.5,
        rightOpacity: right > left ? 1 : 0.5,
        isLeftSideSymmetry: left > right,
      };
    } else {
      return {
        range: 'green',
        value: null,
        leftOpacity: 0.5,
        rightOpacity: 0.5,
      };
    }
  }
}
